import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import useAchieversData from "./data/authorsTableData";
import * as XLSX from "xlsx";

function AchieversTable() {
  const { columns, rows, achievers, totalAchievers } = useAchieversData();

  const [searchQuery1, setSearchQuery1] = useState("");
  const [searchQuery2, setSearchQuery2] = useState("");
  const [sortOrder, setSortOrder] = useState("none");

  const filteredAchievers = rows.filter((achiever) => {
    const name = achiever.achiever?.props?.name?.toLowerCase() || "";
    const mobile = achiever.mobileNumber?.props?.children?.toString()?.toLowerCase() || "";

    const query1Match =
      !searchQuery1 ||
      name.includes(searchQuery1.toLowerCase()) ||
      mobile.includes(searchQuery1.toLowerCase());

    const mala = achiever.malaCountWhenFrameRequested?.props?.children?.toString() || "0";
    const query2Match = !searchQuery2 || mala.includes(searchQuery2);

    return query1Match && query2Match;
  });

  const sortedAchievers = [...filteredAchievers].sort((a, b) => {
    const malaA = a.malaCountWhenFrameRequested?.props?.children || 0;
    const malaB = b.malaCountWhenFrameRequested?.props?.children || 0;

    if (sortOrder === "high-to-low") return malaB - malaA;
    if (sortOrder === "low-to-high") return malaA - malaB;
    return 0;
  });

  const exportToExcel = () => {
    const formatDate = (timestamp) =>
      timestamp ? new Date(timestamp).toLocaleDateString() : "N/A";

    const filteredRawAchievers = achievers.filter((achiever) => {
      const name = achiever.fullName?.toLowerCase() || "";
      const malaCountStr = achiever.malaCountWhenFrameRequested?.toString() || "0";

      return (
        name.includes(searchQuery1.toLowerCase()) &&
        malaCountStr.includes(searchQuery2.toLowerCase())
      );
    });

    const sortedRawAchievers = [...filteredRawAchievers].sort((a, b) => {
      const malaA = a.malaCountWhenFrameRequested || 0;
      const malaB = b.malaCountWhenFrameRequested || 0;

      if (sortOrder === "high-to-low") return malaB - malaA;
      if (sortOrder === "low-to-high") return malaA - malaB;
      return 0;
    });

    const formattedData = sortedRawAchievers.map((achiever) => ({
      Name: achiever.fullName || "N/A",
      Mobile: achiever.mobileNumber || "N/A",
      City: achiever.city || "N/A",
      Address: achiever.address || "N/A",
      Pin: achiever.pinCode || "N/A",
      "Request Date": formatDate(achiever.requestSubmitDate),
      "Mala Count": achiever.malaCountWhenFrameRequested || 0,
      "Selected Frame": achiever.selectedGodFrameImage || "No Image",
      "Dial Code": `${achiever.dialCode || ""} - ${achiever.countryCode || ""}`,
      "Frame Collected": achiever.isFrameCollected ? "Collected" : "Not Collected",
    }));

    const ws = XLSX.utils.json_to_sheet(formattedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Achievers");
    XLSX.writeFile(wb, "Achievers_Details.xlsx");
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={2}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Achievers
                </MDTypography>
              </MDBox>

              <MDBox pt={3} pb={3} mx={2}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={2}>
                    <MDBox mt={2}>
                      <MDTypography variant="h6">Total Achievers: {totalAchievers}</MDTypography>
                    </MDBox>
                  </Grid>

                  <Grid item xs={12} sm={6} md={2}>
                    <TextField
                      label="Search by Name or Mobile No."
                      variant="outlined"
                      fullWidth
                      value={searchQuery1}
                      onChange={(e) => setSearchQuery1(e.target.value)}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={2}>
                    <TextField
                      label="Search by Mala Count"
                      variant="outlined"
                      fullWidth
                      value={searchQuery2}
                      onChange={(e) => setSearchQuery2(e.target.value)}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={2}>
                    <FormControl fullWidth sx={{ display: "flex", height: "44px" }}>
                      <InputLabel>Sort by Mala Count</InputLabel>
                      <Select
                        value={sortOrder}
                        onChange={(e) => setSortOrder(e.target.value)}
                        label="Sort by Mala Count"
                        sx={{ height: "100%" }}
                      >
                        <MenuItem value="none">None</MenuItem>
                        <MenuItem value="high-to-low">High to Low</MenuItem>
                        <MenuItem value="low-to-high">Low to High</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={exportToExcel}
                      style={{ color: "white" }}
                    >
                      Export to Excel
                    </Button>
                  </Grid>
                </Grid>
              </MDBox>

              <MDBox>
                <DataTable
                  table={{ columns, rows: sortedAchievers }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={true}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {/* <Footer /> */}
    </DashboardLayout>
  );
}

export default AchieversTable;
